// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__yfRMG","headerTitle":"Header_headerTitle__2hSMb","fob":"Header_fob__1nGwj"};